export const AUTH_SIGN = 'jI2EjrCx1GQ1q90SWhJinnxAjYzo';
